import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../scss/dashboard.scss';
import Header from '../components/header';
import axios from 'axios';
import BaseURL from '../assets/contants/BaseURL';
import Spinner from '../components/Spinner';

const Groupportal = () => {
    const [loading, setLoading] = useState(true);
    const [historicalData, setHistoricalData] = useState({});
    const [machine, setMachine] = useState([]);
    const [selectedMachine, setSelectedMachine] = useState(null);
    const [selectedDate, setSelectedDate] = useState('');
    const [machineData, setMachineData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchMachines = async () => {
            const token = sessionStorage.getItem('token');
            setLoading(true);
            try {
                const response = await axios.get(`${BaseURL}meters/enpi-machine/`,
                    {
                        headers: {
                            'Authorization': `Token ${token}`
                        }
                    }
                );
                setMachine(response.data);
            } catch (error) {
                console.error('Error fetching machines:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchMachines();
    }, []);

    useEffect(() => {
        if (!selectedMachine) return;

        const fetchTodayData = async () => {
            const token = sessionStorage.getItem('token');
            try {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 2);
                const yesterdayFormatted = yesterday.toISOString().split('T')[0];

                const todayResponse = await axios.get(`${BaseURL}meters/enpi-dashboard-update/`, {
                    params: {
                        department: selectedMachine.id,
                        date: yesterdayFormatted
                    },
                    headers: {
                        'Authorization': `Token ${token}`
                    }
                });
                console.log("Today response", todayResponse.data)
                setMachineData(todayResponse.data[0] || {});

            } catch (error) {
                console.error('Error fetching today\'s machine data:', error);
            }
        };

        fetchTodayData();
    }, [selectedMachine]);

    useEffect(() => {
        if (!selectedMachine) return;

        const fetchHistoricalData = async () => {
            const token = sessionStorage.getItem('token');
            try {
                const historicalDate = selectedDate || new Date(new Date().setDate(new Date().getDate() - 1));
                const historicalFormatted = new Date(historicalDate).toISOString().split('T')[0];

                const historicalResponse = await axios.get(`${BaseURL}meters/enpi-dashboard-update/`, {
                    params: {
                        department: selectedMachine.id,
                        date: historicalFormatted
                    },
                    headers: {
                        'Authorization': `Token ${token}`
                    }
                });
                console.log("Hist response", historicalResponse.data)
                setHistoricalData(prev => ({
                    ...prev,
                    [selectedMachine.id]: historicalResponse.data[0] || {}
                }));

            } catch (error) {
                console.error('Error fetching historical machine data:', error);
            }
        };

        fetchHistoricalData();
    }, [selectedMachine, selectedDate]);

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    const handleMachineChange = (e) => {
        const value = e.target.value;
        if (value === "") {
            setSelectedMachine(null);
            setMachineData(null);
        } else {
            const selected = machine.find(m => m.id.toString() === value);
            setSelectedMachine(selected);
        }
    };

    const formatDate = (date) => {
        if (!date) return "";
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDateForInput = (date) => {
        if (!date) return "";
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const handleMachineWidgetClick = (machine_id, machineId, machineName, products) => {
        navigate('/EMS/productionSub', { state: { machine_id, machineId, machineName, products } });
    };

    const lightenColor = (color, percent) => {
        if (!color) return "#0093ff";
        const hex = color.replace("#", "");
        if (hex.length !== 3 && hex.length !== 6) return "#0093ff";

        const num = parseInt(hex, 16);
        if (isNaN(num)) return "#0093ff";

        const amt = Math.round(2.55 * percent);
        const R = (num >> 16) + amt;
        const G = ((num >> 8) & 0x00ff) + amt;
        const B = (num & 0x0000ff) + amt;

        return (
            "#" +
            (
                0x1000000 +
                (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                (B < 255 ? (B < 1 ? 0 : B) : 255)
            )
                .toString(16)
                .slice(1)
        );
    };

    const getProductFields = (data) => {
        if (!data) return [];
        const excludedFields = ['id', 'Date', 'From', 'To', 'Department', 'kWh', 'Cost', 'Diesel', 'LPG'];
        return Object.keys(data).filter(key =>
            !excludedFields.includes(key) &&
            typeof data[key] === 'string' &&
            data[key].includes('/')
        );
    };

    const parseEnergyData = (data, energyType) => {
        if (!data || !data[energyType]) return { value: 0, target: 0, unit: "" };

        const parts = data[energyType].split('/');
        const valuePart = parts[0].trim();
        const targetPart = parts[1].trim();
        const value = parseFloat(valuePart.split(' ')[0]);
        const target = parseFloat(targetPart.split(' ')[0]);
        const unit = energyType === 'kWh' ? 'kWh' :
            energyType === 'Diesel' ? 'L' :
                'kg';

        return {
            value: isNaN(value) ? 0 : value,
            target: isNaN(target) ? 0 : target,
            unit
        };
    };

    const parseProductData = (data, productName) => {
        if (!data || !data[productName]) return { count: 0, target: 0, unit: "" };

        const parts = data[productName].split('/');
        const countPart = parts[0].trim();
        const targetPart = parts[1].trim();
        const countValue = parseFloat(countPart.split(' ')[0]);
        const countUnit = countPart.split(' ').slice(1).join(' ');
        const targetValue = parseFloat(targetPart.split(' ')[0]);
        const targetUnit = targetPart.split(' ').slice(1).join(' ');
        const unit = countUnit || targetUnit;

        return {
            count: isNaN(countValue) ? 0 : countValue,
            target: isNaN(targetValue) ? 0 : targetValue,
            unit
        };
    };

    const getEnpiColor = (currentValue, targetValue) => {
        const current = typeof currentValue === 'string' 
            ? parseFloat(currentValue.replace(/[^\d.-]/g, '')) 
            : Number(currentValue);
        
        const target = typeof targetValue === 'string' 
            ? parseFloat(targetValue.replace(/[^\d.-]/g, '')) 
            : Number(targetValue);

        if (isNaN(current) || isNaN(target)) {
            return '#ffffff';
        }
        
        if (target === 0) {
            return '#b5b5b5';
        }
        return current >= target ? '#F44336' : '#4CAF50';
    };

    const renderEnergyAndProductSections = (todayData, historicalData) => {
        if (!todayData || !selectedMachine) return null;

        const products = getProductFields(todayData);
        const electricityToday = parseEnergyData(todayData, 'kWh');
        const dieselToday = parseEnergyData(todayData, 'Diesel');
        const lpgToday = parseEnergyData(todayData, 'LPG');

        const electricityHist = parseEnergyData(historicalData, 'kWh');
        const dieselHist = parseEnergyData(historicalData, 'Diesel');
        const lpgHist = parseEnergyData(historicalData, 'LPG');

        const dieselKwhToday = parseFloat(todayData.diesel_kWh || 0);
        const lpgKwhToday = parseFloat(todayData.lpg_kWh || 0);
        const dieselKwhHist = parseFloat(historicalData.diesel_kWh || 0);
        const lpgKwhHist = parseFloat(historicalData.lpg_kWh || 0);

        const totalAllKwhToday = parseFloat(todayData.total_all_kWh || 0);
        const totalAllKwhHist = parseFloat(historicalData.total_all_kWh || 0);

        return (
            <div style={{ width: '100%' }}>
                {/* Header Row with Icons */}
                <div style={{ display: 'flex', marginBottom: '10px' }}>
                    <div style={{ flex: '0 0 100px' }}></div>
                    <div style={{ flex: '0 0 20px' }}></div>
                    <div style={{ 
                        flex: 1, 
                        display: 'flex', 
                        justifyContent: 'space-around', 
                        marginLeft: '20px',
                        position: 'relative',
                        paddingRight: '20px'
                    }}>
                        <div style={{ textAlign: 'center', flex: 1, color: 'black' }}>
                            Electricity
                        </div>
                        {selectedMachine.diesel && (
                            <div style={{ textAlign: 'center', flex: 1, color: 'black' }}>
                                Diesel
                            </div>
                        )}
                        {selectedMachine.lpg && (
                            <div style={{ textAlign: 'center', flex: 1, color: 'black' }}>
                                LPG
                            </div>
                        )}
                        <div style={{ 
                            textAlign: 'center', 
                            flex: 1, 
                            color: 'black',
                            position: 'relative',
                            marginRight: '10px'
                        }}>
                            Total
                            <div style={{
                                position: 'absolute',
                                right: '-15px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                height: '25px',
                                width: '2px',
                                backgroundColor: '#ccc',
                            }}></div>
                        </div>
                    </div>
                    <div style={{ 
                        flex: 1, 
                        display: 'flex', 
                        justifyContent: 'space-around',
                        paddingLeft: '20px'
                    }}>
                        <div style={{ textAlign: 'center', flex: 1, color: 'black' }}>
                            Electricity
                        </div>
                        {selectedMachine.diesel && (
                            <div style={{ textAlign: 'center', flex: 1, color: 'black' }}>
                                Diesel
                            </div>
                        )}
                        {selectedMachine.lpg && (
                            <div style={{ textAlign: 'center', flex: 1, color: 'black' }}>
                                LPG
                            </div>
                        )}
                        <div style={{ textAlign: 'center', flex: 1, color: 'black' }}>
                            Total
                        </div>
                    </div>
                </div>

                {/* Combined Energy Section */}
                <div style={{ 
                    backgroundColor: '#f9f9f9', 
                    borderRadius: '8px', 
                    border: '1px solid #ddd', 
                    padding: '10px', 
                    marginBottom: '15px'
                }}>
                    {/* Actual Energy Row */}
                    <div style={{ display: 'flex', marginBottom: '15px' }}>
                        <div style={{ flex: '0 0 100px', fontWeight: 'bold', display: 'flex', alignItems: 'center', color: 'black', marginLeft: '20px' }}>
                            Actual Energy
                        </div>
                        <div style={{ flex: '0 0 20px', display: 'flex', alignItems: 'center' }}>:</div>

                        {/* Historical Data */}
                        <div style={{ 
                            flex: 1, 
                            display: 'flex', 
                            justifyContent: 'space-around',
                            position: 'relative',
                            paddingRight: '20px'
                        }}>
                            <div style={{
                                flex: 1,
                                color: 'black',
                                borderRadius: '15px',
                                padding: '5px',
                                textAlign: 'center',
                                margin: '0 5px'
                            }}>
                                
                            </div>
                            {selectedMachine.diesel && (
                                <div style={{
                                    flex: 1,
                                    backgroundColor: '#ffd966',
                                    color: 'black',
                                    border: '2px solid #664d00',
                                    borderRadius: '15px',
                                    padding: '5px',
                                    textAlign: 'center',
                                    margin: '0 5px'
                                }}>
                                    <div style={{ fontWeight: 'bold' }}>
                                        {dieselHist.value.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </div>
                                    <div>{dieselHist.unit}</div>
                                </div>
                            )}
                            {selectedMachine.lpg && (
                                <div style={{
                                    flex: 1,
                                    backgroundColor: '#6c6c6c',
                                    color: 'black',
                                    border: '2px solid #767676',
                                    borderRadius: '15px',
                                    padding: '5px',
                                    textAlign: 'center',
                                    margin: '0 5px'
                                }}>
                                    <div style={{ fontWeight: 'bold' }}>
                                        {lpgHist.value.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </div>
                                    <div>{lpgHist.unit}</div>
                                </div>
                            )}
                            <div style={{
                                flex: 1,
                                color: 'black',
                                borderRadius: '15px',
                                padding: '5px',
                                textAlign: 'center',
                                margin: '0 5px',
                                position: 'relative',
                                marginRight: '10px'
                            }}>
                                <div style={{ fontWeight: 'bold' }}>
                                    
                                </div>
                                <div style={{
                                    position: 'absolute',
                                    right: '-15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    height: '45px',
                                    width: '2px',
                                    backgroundColor: '#ccc',
                                }}></div>
                            </div>
                        </div>

                        {/* Today's Data */}
                        <div style={{ 
                            flex: 1, 
                            display: 'flex', 
                            justifyContent: 'space-around',
                            paddingLeft: '20px'
                        }}>
                            <div style={{
                                flex: 1,
                                color: 'black',
                                borderRadius: '15px',
                                padding: '5px',
                                textAlign: 'center',
                                margin: '0 5px'
                            }}>
                                
                            </div>
                            {selectedMachine.diesel && (
                                <div style={{
                                    flex: 1,
                                    backgroundColor: '#ffd966',
                                    color: 'black',
                                    border: '2px solid #664d00',
                                    borderRadius: '15px',
                                    padding: '5px',
                                    textAlign: 'center',
                                    margin: '0 5px'
                                }}>
                                    <div style={{ fontWeight: 'bold' }}>
                                        {dieselToday.value.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </div>
                                    <div>{dieselToday.unit}</div>
                                </div>
                            )}
                            {selectedMachine.lpg && (
                                <div style={{
                                    flex: 1,
                                    backgroundColor: '#6c6c6c',
                                    color: 'black',
                                    border: '2px solid #767676',
                                    borderRadius: '15px',
                                    padding: '5px',
                                    textAlign: 'center',
                                    margin: '0 5px'
                                }}>
                                    <div style={{ fontWeight: 'bold' }}>
                                        {lpgToday.value.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </div>
                                    <div>{lpgToday.unit}</div>
                                </div>
                            )}
                            <div style={{
                                flex: 1,
                                color: 'black',
                                borderRadius: '15px',
                                padding: '5px',
                                textAlign: 'center',
                                margin: '0 5px'
                            }}>
                                <div style={{ fontWeight: 'bold' }}>
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    {/* Total Energy Row */}
                    <div style={{ display: 'flex' }}>
                        <div style={{ flex: '0 0 100px', fontWeight: 'bold', display: 'flex', alignItems: 'center', color: 'black', marginLeft: '20px' }}>
                            Total Energy
                        </div>
                        <div style={{ flex: '0 0 20px', display: 'flex', alignItems: 'center' }}>:</div>

                        {/* Historical Data */}
                        <div style={{ 
                            flex: 1, 
                            display: 'flex', 
                            justifyContent: 'space-around',
                            position: 'relative',
                            paddingRight: '20px'
                        }}>
                            <div style={{
                                flex: 1,
                                backgroundColor: '#026dfe',
                                color: 'black',
                                border: '2px solid #0056b3',
                                borderRadius: '15px',
                                padding: '5px',
                                textAlign: 'center',
                                margin: '0 5px'
                            }}>
                                <div style={{ fontWeight: 'bold' }}>
                                    {electricityHist.value.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}
                                </div>
                                <div>kWh</div>
                            </div>
                            {selectedMachine.diesel && (
                                <div style={{
                                    flex: 1,
                                    backgroundColor: '#ffd966',
                                    color: 'black',
                                    border: '2px solid #664d00',
                                    borderRadius: '15px',
                                    padding: '5px',
                                    textAlign: 'center',
                                    margin: '0 5px'
                                }}>
                                    <div style={{ fontWeight: 'bold' }}>
                                        {dieselKwhHist.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </div>
                                    <div>kWh</div>
                                </div>
                            )}
                            {selectedMachine.lpg && (
                                <div style={{
                                    flex: 1,
                                    backgroundColor: '#6c6c6c',
                                    color: 'black',
                                    border: '2px solid #767676',
                                    borderRadius: '15px',
                                    padding: '5px',
                                    textAlign: 'center',
                                    margin: '0 5px'
                                }}>
                                    <div style={{ fontWeight: 'bold' }}>
                                        {lpgKwhHist.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </div>
                                    <div>kWh</div>
                                </div>
                            )}
                            <div style={{
                                flex: 1,
                                backgroundColor: '#4CAF50',
                                color: 'black',
                                border: '2px solid #2E7D32',
                                borderRadius: '15px',
                                padding: '5px',
                                textAlign: 'center',
                                margin: '0 5px',
                                position: 'relative',
                                marginRight: '10px'
                            }}>
                                <div style={{ fontWeight: 'bold' }}>
                                    {totalAllKwhHist.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}
                                </div>
                                <div>kWh</div>
                                <div style={{
                                    position: 'absolute',
                                    right: '-15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    height: '45px',
                                    width: '2px',
                                    backgroundColor: '#ccc',
                                }}></div>
                            </div>
                        </div>

                        {/* Today's Data */}
                        <div style={{ 
                            flex: 1, 
                            display: 'flex', 
                            justifyContent: 'space-around',
                            paddingLeft: '20px'
                        }}>
                            <div style={{
                                flex: 1,
                                backgroundColor: '#026dfe',
                                color: 'black',
                                border: '2px solid #0056b3',
                                borderRadius: '15px',
                                padding: '5px',
                                textAlign: 'center',
                                margin: '0 5px'
                            }}>
                                <div style={{ fontWeight: 'bold' }}>
                                    {electricityToday.value.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}
                                </div>
                                <div>kWh</div>
                            </div>
                            {selectedMachine.diesel && (
                                <div style={{
                                    flex: 1,
                                    backgroundColor: '#ffd966',
                                    color: 'black',
                                    border: '2px solid #664d00',
                                    borderRadius: '15px',
                                    padding: '5px',
                                    textAlign: 'center',
                                    margin: '0 5px'
                                }}>
                                    <div style={{ fontWeight: 'bold' }}>
                                        {dieselKwhToday.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </div>
                                    <div>kWh</div>
                                </div>
                            )}
                            {selectedMachine.lpg && (
                                <div style={{
                                    flex: 1,
                                    backgroundColor: '#6c6c6c',
                                    color: 'black',
                                    border: '2px solid #767676',
                                    borderRadius: '15px',
                                    padding: '5px',
                                    textAlign: 'center',
                                    margin: '0 5px'
                                }}>
                                    <div style={{ fontWeight: 'bold' }}>
                                        {lpgKwhToday.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                    </div>
                                    <div>kWh</div>
                                </div>
                            )}
                            <div style={{
                                flex: 1,
                                backgroundColor: '#4CAF50',
                                color: 'black',
                                border: '2px solid #2E7D32',
                                borderRadius: '15px',
                                padding: '5px',
                                textAlign: 'center',
                                margin: '0 5px'
                            }}>
                                <div style={{ fontWeight: 'bold' }}>
                                    {totalAllKwhToday.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}
                                </div>
                                <div>kWh</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Product Rows */}
                {products.map(productName => {
                    const productToday = parseProductData(todayData, productName);
                    const productHist = parseProductData(historicalData, productName);

                    const electricityPerUnitToday = electricityToday.value && productToday.count ? (electricityToday.value / productToday.count).toFixed(0) : 0;
                    const dieselPerUnitToday = dieselToday.value && productToday.count ? (dieselToday.value / productToday.count).toFixed(0) : 0;
                    const lpgPerUnitToday = lpgToday.value && productToday.count ? (lpgToday.value / productToday.count).toFixed(0) : 0;

                    const electricityPerUnitHist = electricityHist.value && productHist.count ? (electricityHist.value / productHist.count).toFixed(0) : 0;
                    const dieselPerUnitHist = dieselHist.value && productHist.count ? (dieselHist.value / productHist.count).toFixed(0) : 0;
                    const lpgPerUnitHist = lpgHist.value && productHist.count ? (lpgHist.value / productHist.count).toFixed(0) : 0;

                    const electricityTargetPerUnitToday = electricityToday.target ?? 0;
                    const dieselTargetPerUnitToday = dieselToday.target ?? 0;
                    const lpgTargetPerUnitToday = lpgToday.target ?? 0;

                    return (
                        <React.Fragment key={productName}>
                            <div style={{ backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #ddd', padding: '10px', marginBottom: '8px' }}>
                                {/* Product Count Row */}
                                <div style={{ display: 'flex', marginBottom: '10px' }}>
                                    <div style={{ flex: '0 0 100px', fontWeight: 'bold', display: 'flex', alignItems: 'center', color: 'black', marginLeft: '20px' }}>
                                        {productName}
                                    </div>
                                    <div style={{ flex: '0 0 20px', display: 'flex', alignItems: 'center' }}>:</div>

                                    {/* Historical Data */}
                                    <div style={{ 
                                        flex: 1, 
                                        display: 'flex', 
                                        justifyContent: 'space-around',
                                        position: 'relative',
                                        paddingRight: '20px'
                                    }}>
                                        <div style={{
                                            flex: 1,
                                            backgroundColor: '#348afe',
                                            borderRadius: '8px',
                                            padding: '5px',
                                            border: '2px solid #0056b3',
                                            textAlign: 'center',
                                            margin: '0 5px'
                                        }}>
                                            <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                {productHist.count.toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </div>
                                            <div style={{ color: 'black' }}>{productHist.unit}</div>
                                        </div>
                                        {selectedMachine.diesel && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: '#ffe699',
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #806600',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {productHist.count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                                <div style={{ color: 'black' }}>{productHist.unit}</div>
                                            </div>
                                        )}
                                        {selectedMachine.lpg && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: '#818181',
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #767676',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {productHist.count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                                <div style={{ color: 'black' }}>{productHist.unit}</div>
                                            </div>
                                        )}
                                        <div style={{
                                            flex: 1,
                                            color: 'black',
                                            borderRadius: '15px',
                                            padding: '5px',
                                            textAlign: 'center',
                                            margin: '0 5px',
                                            position: 'relative',
                                            marginRight: '10px'
                                        }}>
                                            <div style={{ fontWeight: 'bold' }}>
                                                
                                            </div>
                                            <div style={{
                                                position: 'absolute',
                                                right: '-15px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                height: '45px',
                                                width: '2px',
                                                backgroundColor: '#ccc',
                                            }}></div>
                                        </div>
                                    </div>

                                    {/* Today's Data */}
                                    <div style={{ 
                                        flex: 1, 
                                        display: 'flex', 
                                        justifyContent: 'space-around',
                                        paddingLeft: '20px'
                                    }}>
                                        <div style={{
                                            flex: 1,
                                            backgroundColor: '#348afe',
                                            borderRadius: '8px',
                                            padding: '5px',
                                            border: '2px solid #0056b3',
                                            textAlign: 'center',
                                            margin: '0 5px'
                                        }}>
                                            <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                {productToday.count.toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </div>
                                            <div style={{ color: 'black' }}>{productToday.unit}</div>
                                        </div>
                                        {selectedMachine.diesel && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: '#ffe699',
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #806600',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {productToday.count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                                <div style={{ color: 'black' }}>{productToday.unit}</div>
                                            </div>
                                        )}
                                        {selectedMachine.lpg && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: '#818181',
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #767676',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {productToday.count.toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                                <div style={{ color: 'black' }}>{productToday.unit}</div>
                                            </div>
                                        )}
                                        <div style={{
                                            flex: 1,
                                            color: 'black',
                                            borderRadius: '15px',
                                            padding: '5px',
                                            textAlign: 'center',
                                            margin: '0 5px'
                                        }}>
                                            <div style={{ fontWeight: 'bold' }}>
                                                
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>

                                {/* EnPI Row */}
                                <div style={{ display: 'flex', marginBottom: '10px' }}>
                                    <div style={{ flex: '0 0 100px', fontWeight: 'bold', display: 'flex', alignItems: 'center', color: 'black', marginLeft: '20px' }}>
                                        EnPI {productName}
                                    </div>
                                    <div style={{ flex: '0 0 20px', display: 'flex', alignItems: 'center' }}>:</div>

                                    {/* Historical Data */}
                                    <div style={{ 
                                        flex: 1, 
                                        display: 'flex', 
                                        justifyContent: 'space-around',
                                        position: 'relative',
                                        paddingRight: '20px'
                                    }}>
                                        <div style={{
                                            flex: 1,
                                            backgroundColor: getEnpiColor(electricityPerUnitHist, productHist.target),
                                            borderRadius: '8px',
                                            padding: '5px',
                                            border: '2px solid #003d82',
                                            textAlign: 'center',
                                            margin: '0 5px'
                                        }}>
                                            <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                {electricityPerUnitHist}
                                            </div>
                                            <div style={{ color: 'black' }}>kWh/{productHist.unit}</div>
                                        </div>
                                        {selectedMachine.diesel && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: getEnpiColor(dieselPerUnitHist, dieselHist.target),
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #b38f00',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {dieselPerUnitHist}
                                                </div>
                                                <div style={{ color: 'black' }}>L/{productHist.unit}</div>
                                            </div>
                                        )}
                                        {selectedMachine.lpg && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: getEnpiColor(lpgPerUnitHist, lpgHist.target),
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #767676',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {lpgPerUnitHist}
                                                </div>
                                                <div style={{ color: 'black' }}>kg/{productHist.unit}</div>
                                            </div>
                                        )}
                                        <div style={{
                                            flex: 1,
                                            color: 'black',
                                            borderRadius: '15px',
                                            padding: '5px',
                                            textAlign: 'center',
                                            margin: '0 5px',
                                            position: 'relative',
                                            marginRight: '10px'
                                        }}>
                                            <div style={{ fontWeight: 'bold' }}>
                                                
                                            </div>
                                            <div style={{
                                                position: 'absolute',
                                                right: '-15px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                height: '45px',
                                                width: '2px',
                                                backgroundColor: '#ccc',
                                            }}></div>
                                        </div>
                                    </div>

                                    {/* Today's Data */}
                                    <div style={{ 
                                        flex: 1, 
                                        display: 'flex', 
                                        justifyContent: 'space-around',
                                        paddingLeft: '20px'
                                    }}>
                                        <div style={{
                                            flex: 1,
                                            backgroundColor: getEnpiColor(electricityPerUnitToday, electricityTargetPerUnitToday),
                                            borderRadius: '8px',
                                            padding: '5px',
                                            border: '2px solid #003d82',
                                            textAlign: 'center',
                                            margin: '0 5px'
                                        }}>
                                            <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                {electricityPerUnitToday}
                                            </div>
                                            <div style={{ color: 'black' }}>kWh/{productToday.unit}</div>
                                        </div>
                                        {selectedMachine.diesel && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: getEnpiColor(dieselPerUnitToday, dieselTargetPerUnitToday),
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #b38f00',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {dieselPerUnitToday}
                                                </div>
                                                <div style={{ color: 'black' }}>L/{productToday.unit}</div>
                                            </div>
                                        )}
                                        {selectedMachine.lpg && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: getEnpiColor(lpgPerUnitToday, lpgTargetPerUnitToday),
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #767676',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {lpgPerUnitToday}
                                                </div>
                                                <div style={{ color: 'black' }}>kg/{productToday.unit}</div>
                                            </div>
                                        )}
                                        <div style={{
                                            flex: 1,
                                            color: 'black',
                                            borderRadius: '15px',
                                            padding: '5px',
                                            textAlign: 'center',
                                            margin: '0 5px'
                                        }}>
                                            <div style={{ fontWeight: 'bold' }}>
                                                
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>

                                {/* Target Row */}
                                <div style={{ display: 'flex' }}>
                                    <div style={{ flex: '0 0 100px', fontWeight: 'bold', display: 'flex', alignItems: 'center', color: 'black', marginLeft: '20px' }}>
                                        Target {productName}
                                    </div>
                                    <div style={{ flex: '0 0 20px', display: 'flex', alignItems: 'center' }}>:</div>

                                    {/* Historical Data */}
                                    <div style={{ 
                                        flex: 1, 
                                        display: 'flex', 
                                        justifyContent: 'space-around',
                                        position: 'relative',
                                        paddingRight: '20px'
                                    }}>
                                        <div style={{
                                            flex: 1,
                                            backgroundColor: '#a4cafd',
                                            borderRadius: '8px',
                                            padding: '5px',
                                            border: '2px solid #002050',
                                            textAlign: 'center',
                                            margin: '0 5px'
                                        }}>
                                            <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                {productHist.target.toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </div>
                                            <div style={{ color: 'black' }}>kWh/{productHist.unit}</div>
                                        </div>
                                        {selectedMachine.diesel && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: '#fff3b8',
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #b38f00',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {dieselHist.target.toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                                <div style={{ color: 'black' }}>{dieselHist.unit}/{productHist.unit}</div>
                                            </div>
                                        )}
                                        {selectedMachine.lpg && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: '#dcdcdb',
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #767676',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {lpgHist.target.toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                                <div style={{ color: 'black' }}>{lpgHist.unit}/{productHist.unit}</div>
                                            </div>
                                        )}
                                        <div style={{
                                            flex: 1,
                                            color: 'black',
                                            borderRadius: '15px',
                                            padding: '5px',
                                            textAlign: 'center',
                                            margin: '0 5px',
                                            position: 'relative',
                                            marginRight: '10px'
                                        }}>
                                            <div style={{ fontWeight: 'bold' }}>
                                                
                                            </div>
                                            <div style={{
                                                position: 'absolute',
                                                right: '-15px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                height: '45px',
                                                width: '2px',
                                                backgroundColor: '#ccc',
                                            }}></div>
                                        </div>
                                    </div>

                                    {/* Today's Data */}
                                    <div style={{ 
                                        flex: 1, 
                                        display: 'flex', 
                                        justifyContent: 'space-around',
                                        paddingLeft: '20px'
                                    }}>
                                        <div style={{
                                            flex: 1,
                                            backgroundColor: '#a4cafd',
                                            borderRadius: '8px',
                                            padding: '5px',
                                            border: '2px solid #002050',
                                            textAlign: 'center',
                                            margin: '0 5px'
                                        }}>
                                            <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                {productToday.target.toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </div>
                                            <div style={{ color: 'black' }}>kWh/{productToday.unit}</div>
                                        </div>
                                        {selectedMachine.diesel && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: '#fff3b8',
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #b38f00',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {dieselToday.target.toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                                <div style={{ color: 'black' }}>{dieselToday.unit}/{productToday.unit}</div>
                                            </div>
                                        )}
                                        {selectedMachine.lpg && (
                                            <div style={{
                                                flex: 1,
                                                backgroundColor: '#dcdcdb',
                                                borderRadius: '8px',
                                                padding: '5px',
                                                border: '2px solid #767676',
                                                textAlign: 'center',
                                                margin: '0 5px'
                                            }}>
                                                <div style={{ fontWeight: 'bold', color: 'black' }}>
                                                    {lpgToday.target.toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </div>
                                                <div style={{ color: 'black' }}>{lpgToday.unit}/{productToday.unit}</div>
                                            </div>
                                        )}
                                        <div style={{
                                            flex: 1,
                                            color: 'black',
                                            borderRadius: '15px',
                                            padding: '5px',
                                            textAlign: 'center',
                                            margin: '0 5px'
                                        }}>
                                            <div style={{ fontWeight: 'bold' }}>
                                                
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        );
    };

    const renderMachineWidgets = () => {
        if (!machineData || Object.keys(machineData).length === 0 || selectedMachine === "") {
            return (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <h3 className="dashboard-subtitle" style={{ color: '#333', marginBottom: '15px' }}>
                        EnPI Departments
                    </h3>
                    <div style={{
                        display: 'inline-block',
                        position: 'relative',
                        marginBottom: '20px'
                    }}>
                        <select
                            value={selectedMachine?.id || ''}
                            onChange={handleMachineChange}
                            style={{
                                border: '2px solid #4a90e2',
                                borderRadius: '8px',
                                padding: '10px 40px 10px 15px',
                                fontSize: '16px',
                                width: '300px',
                                backgroundColor: '#f8f9fa',
                                color: '#333',
                                cursor: 'pointer',
                                appearance: 'none',
                                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                transition: 'all 0.3s ease',
                                outline: 'none',
                                textAlign: 'center',
                                ':hover': {
                                    borderColor: '#357abD',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                }
                            }}
                        >
                            <option value="">Select a Department</option>
                            {machine.map(machine => (
                                <option key={machine.id} value={machine.id}>
                                    {machine.machine_name}
                                </option>
                            ))}
                        </select>
                        <div style={{
                            position: 'absolute',
                            right: '15px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            pointerEvents: 'none',
                            color: '#4a90e2'
                        }}>
                            ▼
                        </div>
                    </div>
                    <p style={{
                        marginTop: '15px',
                        color: '#666',
                        fontStyle: 'italic'
                    }}>
                        {selectedMachine === "" ? "Please select a Department to view data" : "No department selected"}
                    </p>
                </div>
            );
        }

        const widgetColor = machineData.group_color ? machineData.group_color : '#0093ff';
        const historicalMachineData = historicalData[selectedMachine.id] || {};
        const lightBackground = lightenColor(widgetColor, 85);
        const products = getProductFields(machineData);
        const productCount = products.length;
        const baseHeight = 250;
        const heightPerProduct = 250;
        const widgetHeight = baseHeight + (productCount * heightPerProduct);

        // Calculate column count based on enabled features
        const columnCount = 1 + (selectedMachine.diesel ? 1 : 0) + (selectedMachine.lpg ? 1 : 0);

        return (
            <div>
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <h3 className="dashboard-subtitle" style={{ color: '#333', marginBottom: '15px' }}>
                        EnPI Departments
                    </h3>
                    <div style={{
                        display: 'inline-block',
                        position: 'relative',
                        marginBottom: '20px'
                    }}>
                        <select
                            value={selectedMachine.id || ''}
                            onChange={handleMachineChange}
                            style={{
                                border: '2px solid #4a90e2',
                                borderRadius: '8px',
                                padding: '10px 40px 10px 15px',
                                fontSize: '16px',
                                width: '300px',
                                backgroundColor: '#f8f9fa',
                                color: '#333',
                                cursor: 'pointer',
                                appearance: 'none',
                                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                transition: 'all 0.3s ease',
                                outline: 'none',
                                textAlign: 'center',
                                ':hover': {
                                    borderColor: '#357abD',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                }
                            }}
                        >
                            <option value="">Select a Department</option>
                            {machine.map(machine => (
                                <option key={machine.id} value={machine.id}>
                                    {machine.machine_name}
                                </option>
                            ))}
                        </select>
                        <div style={{
                            position: 'absolute',
                            right: '15px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            pointerEvents: 'none',
                            color: '#4a90e2',
                            fontSize: '12px'
                        }}>
                            ▼
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '20px',
                        justifyContent: 'center',
                    }}
                >
                    <div
                        key={machineData.id}
                        onClick={() => handleMachineWidgetClick(selectedMachine.id, selectedMachine.machine_id, machineData.Department || machineData.machine_name, products)}
                        style={{
                            width: `${columnCount * 300 + 200}px`, // Adjust width based on column count
                            height: `${widgetHeight}px`,
                            backgroundColor: '#ffffff',
                            border: `4px solid ${widgetColor}`,
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                            position: 'relative',
                            cursor: 'pointer'
                        }}
                        className="widgets"
                    >
                        <h4
                            style={{
                                margin: '5px 0',
                                color: widgetColor,
                                fontSize: '16px',
                                fontWeight: 'bold',
                                border: `2px solid ${widgetColor}`,
                                borderRadius: '20px',
                                padding: '4px 12px',
                                display: 'inline-block',
                                backgroundColor: lightBackground,
                            }}
                        >
                            {machineData.Department || machineData.machine_name}
                        </h4>

                        {/* Date Selection */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            margin: '15px 0'
                        }}>
                            <div style={{ flex: 1, textAlign: 'center', marginRight: '-150px', marginLeft: '100px' }}>
                                <input
                                    type="date"
                                    id="historicalDate"
                                    value={selectedDate || formatDateForInput(new Date(new Date().setDate(new Date().getDate() - 1)))}
                                    onChange={handleDateChange}
                                    max={formatDateForInput(new Date(new Date().setDate(new Date().getDate())))}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                        backgroundColor: lightBackground,
                                        border: `1px solid ${widgetColor}`,
                                        borderRadius: '4px',
                                        color: widgetColor,
                                        padding: '2px 5px',
                                        fontSize: '12px',
                                    }}
                                />
                            </div>
                            <div style={{ flex: 1, textAlign: 'center' }}>
                                <span style={{
                                    backgroundColor: lightBackground,
                                    border: `1px solid ${widgetColor}`,
                                    borderRadius: '4px',
                                    color: widgetColor,
                                    padding: '3px 10px',
                                    fontSize: '12px',
                                }}>
                                    {formatDate(new Date(new Date().setDate(new Date().getDate() - 2)))}
                                </span>
                            </div>
                        </div>

                        {/* Main Data Section */}
                        <div style={{ marginBottom: '20px' }}>
                            {renderEnergyAndProductSections(machineData, historicalMachineData)}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="dashboard-container">
            <Header title="BRADKEN EnPI MANAGEMENT DASHBOARD" />
            <div className="card-container" style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                marginTop: '50px',
                maxWidth: '1000px',
                marginLeft: 'auto',
                marginRight: 'auto'
            }}>
                <div className="machine-card">
                    {loading ? <Spinner /> : renderMachineWidgets()}
                </div>
            </div>
        </div>
    );
};

export default Groupportal;